import React, { forwardRef, useId } from 'react';
import 'polished';
import '@s-group/design-system-tokens/web/tokens/size.es6.js';
import { useCombinedRef } from '../common/hooks.js';
import { useFocusTrap } from './hooks.js';
import { ModalHeader } from './ModalHeader.js';
import styled from 'styled-components';
import { ModalStyle } from './Modal.styles.js';

const _ModalDialog = forwardRef(({ announceContent, 'aria-describedby': propAriaDescribedby, children, closeButton, cover, // Used only in styling, prevent passing it to DOM
divider, // Used only in styling, prevent passing it to DOM
footer, header, icon, id: propId, onClick: customModalDialogOnClickHandler, position, // Used only in styling, prevent passing it to DOM
role = 'dialog', rounding, // Used only in styling, prevent passing it to DOM
sizing, width, // Used only in styling, prevent passing it to DOM
...rest }, forwardedRef) => {
    const modalRef = useFocusTrap();
    const ref = useCombinedRef(modalRef, forwardedRef);
    const id = propId !== null && propId !== void 0 ? propId : useId();
    const headerId = header ? `${id}header` : undefined;
    const bodyId = `${id}body`;
    const handleModalDialogClick = (event) => {
        if (customModalDialogOnClickHandler) {
            customModalDialogOnClickHandler(event);
        }
        // Prevent event bubbling to blanket onClick handler
        event.stopPropagation();
    };
    const getAriaDescribedby = () => {
        if (announceContent === false) {
            return; // Announcement is denied
        }
        if (propAriaDescribedby) {
            return propAriaDescribedby; // Has a custom reference
        }
        if (announceContent === true || // Announcement is enforced
            role === 'alertdialog' || // Alert is always announced
            typeof children === 'string' // Content is static
        ) {
            return bodyId;
        }
    };
    return (React.createElement("div", { "aria-labelledby": headerId, "aria-describedby": getAriaDescribedby(), "aria-modal": "true", id: id, onClick: handleModalDialogClick, role: role, ...rest, ref: ref },
        header && (React.createElement(ModalHeader, { className: "modal-header", closeButton: closeButton, icon: icon, id: headerId, sizing: sizing }, header)),
        children && (React.createElement("div", { className: "modal-body", id: bodyId }, children)),
        footer && React.createElement("div", { className: "modal-footer" }, footer)));
});
_ModalDialog.displayName = '_ModalDialog';
const ModalDialog = styled(_ModalDialog) `
    ${ModalStyle}
`;

export { ModalDialog };
//# sourceMappingURL=ModalDialog.js.map
